module.exports = __webpack_public_path__ + "toGroom-we-b-w.36ecb3c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-b-w.jpg
// module id = MKZ7
// module chunks = 0